import type { LabelWithRole } from '@skop-app/lib-domain/types'

import { isNonEmptyString } from '@/utils/typeGuards'

type UserLike = {
  id?: string
  name?: string
}

const setNameIfPresent = (
  target: Record<string, string>,
  id: unknown,
  label: unknown,
) => {
  if (!isNonEmptyString(id) || !isNonEmptyString(label)) return
  target[id] = label
}

export const buildUserNamesById = (params: {
  user?: UserLike
  teammates?: LabelWithRole[]
}): Record<string, string> => {
  const { user, teammates = [] } = params
  const lookup: Record<string, string> = {}

  setNameIfPresent(lookup, user?.id, user?.name)
  teammates.forEach((teammate) => {
    setNameIfPresent(lookup, teammate.value, teammate.label)
  })

  return lookup
}

export const getReferenceSourceLabel = (params: {
  organizationID?: string
  byUserID?: string
  organizationNamesById?: Record<string, string>
  userNamesById?: Record<string, string>
}): string => {
  const {
    organizationID,
    byUserID,
    organizationNamesById = {},
    userNamesById = {},
  } = params

  if (!organizationID && isNonEmptyString(byUserID)) {
    return userNamesById[byUserID] ?? 'Custom'
  }

  if (organizationID === process.env.NEXT_PUBLIC_SKOP_ORGID) {
    return 'Skop'
  }

  if (isNonEmptyString(organizationID)) {
    return organizationNamesById[organizationID] ?? 'Custom'
  }

  return 'Custom'
}
